import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';
import { NTAKTicketSettings } from '../../models/serializable/ntak-ticket-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class NTAKTicketSettingsComponent extends Component {
  static readonly TYPE_ID: string = '2ceccb77d0fb4b89a595fbe289a97682';

  private constructor(
    public readonly ticketSettings: NTAKTicketSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return NTAKTicketSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static create(args: {
    ticketSettings: NTAKTicketSettings,
  }): NTAKTicketSettingsComponent {
    return new NTAKTicketSettingsComponent(
        args.ticketSettings,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): NTAKTicketSettingsComponent {
    return new NTAKTicketSettingsComponent(
        context.fromData<NTAKTicketSettings>(MapUtils.get<SerializedData>(map, 'ticketSettings')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      ticketSettings: context.toData(this.ticketSettings),
    };
  }

  clone(): this {
    return new NTAKTicketSettingsComponent(
        this.ticketSettings.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.ticketSettings, this.ticketSettings);
  }
}

export class NTAKTicketSettingsComponentBuilder extends DataModelBuilder<NTAKTicketSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): NTAKTicketSettingsComponent {
    return NTAKTicketSettingsComponent.fromMap(context, map);
  }
}
